import React from 'react';
import {
  ICheckedItems,
  ITreeSection,
} from '../../../../../BaseComponents/TreeSelect/TreeSelectUtils';

interface IArboristTreeContext {
  // onCheck: (id: string, isChecked: boolean) => void;
  showPointerLines?: number;
  parentSectionBoldText?: boolean;
  searchValue?: string;
  showListItemButtons?: (section: ITreeSection) => boolean;
  renderListItemButtons?: (
    section: ITreeSection,
    parent?: ITreeSection
  ) => React.ReactNode;
  hoverChecklistButtons?: (analys: ITreeSection) => boolean;
  renderSecondaryText?: (suggestion: ITreeSection) => React.ReactNode;
  disableSectionsClick?: boolean | ((section: ITreeSection) => boolean);
  onCheck?: (
    sections: ITreeSection[],
    checkedSection: ICheckedItems,
    checked: boolean,
    suggestion?: ITreeSection
  ) => ITreeSection[];
  sectionsUpdate: (sections: ITreeSection[]) => void;
  sections: ITreeSection[];
}

export const ArboristTreeContext = React.createContext<IArboristTreeContext>({
  onCheck: () => [],
  sectionsUpdate: () => {},
  sections: [],
});
